import React from 'react'
import {Parallax, ParallaxLayer} from "react-spring/renderprops-addons";
import ApplicationBar from "./Components/ApplicationBar";
import './Interests.css'



import cloud from './Img/cloud.png'
import ground from './Img/ground.png'
import tent from './Img/tent.png'
import fire from './Img/fire.png'
import pineTree from './Img/pineTrees.png'

import monitor from './Img/monitor.png'
import speaker from './Img/speaker.png'
import keyboard from './Img/keyboardMouse.png'
import siege from './Img/R6Logo.png'
import RL from './Img/rocketLeagueLogo.png'

import Typography from "@material-ui/core/Typography";

class Interests extends React.Component{

    constructor(props) {
        super(props);
    }





    render() {
        return(
        <div>
            <ApplicationBar/>
            <Parallax pages={3} ref={ref => (this.parallax = ref)}>
                <ParallaxLayer offset={0} speed={0} factor={1} style={{backgroundColor: '#03cafc'}}/>

                <ParallaxLayer offset={1} speed={0} className={'hikingSky'}/>
                <ParallaxLayer offset={2} speed={0} className={'gaming'}/>

                <ParallaxLayer offset={.19} speed={.6} style={{ opacity: .7}}>
                    <img src={cloud} style={{marginLeft: '15%', width: '10%', minWidth: 50}}/>
                </ParallaxLayer>
                <ParallaxLayer offset={.2} speed={.8} style={{ opacity: .8}}>
                    <img src={cloud} style={{marginLeft: '65%', width: '12%'}}/>
                </ParallaxLayer>

                <ParallaxLayer offset={.38} speed={-.2}>
                    <Typography style={{color: 'white', position:'absolute', marginLeft: '11%', fontSize: '5vh'}}>
                        Click anywhere on the screen to scroll through my Interests.
                    </Typography>
                </ParallaxLayer>

                <ParallaxLayer offset={1.16} speed={-.65} style={{ opacity: .8}}>
                    <img src={cloud} style={{marginLeft: '10%', width: '10%'}}/>
                </ParallaxLayer>
                <ParallaxLayer offset={1.1} speed={-.6} style={{opacity: .8}}>
                    <img src={cloud} style={{marginLeft: '80%', width: '12%'}}/>
                </ParallaxLayer>
                <ParallaxLayer offset={1.09} speed={-.5} style={{opacity: .8}}>
                    <img src={cloud} style={{marginLeft: '25%', width: '11%'}}/>
                </ParallaxLayer>

                <ParallaxLayer offset={1.15} speed={.5}>
                    <Typography style={{color: 'white', marginLeft: '40%', fontSize: '5vw'}}>
                        Outdoors
                    </Typography>

                </ParallaxLayer>
                <ParallaxLayer offset={1.35} speed={.8}>
                    <Typography style={{color: 'white', marginLeft: '25%', fontSize: '3vw'}}>
                        Camping | Hiking | Snowboarding | Skiing
                    </Typography>

                </ParallaxLayer>
                <ParallaxLayer offset={1.8} speed={.1}>
                    <img src={ground}/>
                </ParallaxLayer>


                <ParallaxLayer offset={1.67} speed={.4}>
                    <img src={pineTree} style={{width: '23%', minWidth: 50}}/>
                </ParallaxLayer>

                <ParallaxLayer offset={1.82} speed={.7}>
                    <img src={tent} style={{width: '15%', marginLeft: '5%'}}/>
                </ParallaxLayer>

                <ParallaxLayer offset={1.86} speed={.8}>
                    <img src={fire} style={{width: '3%', marginLeft: '20%'}}/>

                </ParallaxLayer>

                <ParallaxLayer offset={1.69} speed={.5}>
                    <img src={pineTree} style={{width: '22%', marginLeft: '45%'}}/>
                </ParallaxLayer>
                <ParallaxLayer offset={1.68} speed={.45}>
                    <img src={pineTree} style={{width: '22%', marginLeft: '65%'}}/>
                </ParallaxLayer>




                <ParallaxLayer offset={2.7} speed={.1}>
                    <div style={{backgroundColor: 'grey', height: '30vh'}}/>
                </ParallaxLayer>

                <ParallaxLayer offset={2} speed={.1}>
                    <div style={{backgroundColor: '#D2B48C', height: '70vh'}}/>
                </ParallaxLayer>


                <ParallaxLayer offset={2.15} speed={.5}>
                    <Typography style={{color: 'Black', marginLeft: '40%', fontSize: '10vh'}}>
                        Gaming
                    </Typography>
                </ParallaxLayer>

                <ParallaxLayer offset={2.2} speed={1.5}>
                    <div className={'gaming'} style={{width: window.width}}/>
                </ParallaxLayer>

                <ParallaxLayer offset={2.4} speed={-.2}>
                    <img src={siege} style={{width: '25%', marginLeft: '10%'}}/>

                </ParallaxLayer>
                <ParallaxLayer offset={2.42} speed={-.3}>
                    <img src={RL} style={{width: '20%', marginLeft: '70%'}}/>

                </ParallaxLayer>

                <ParallaxLayer offset={2.4} speed={.5}>
                    <img src={monitor} style={{marginLeft: '38%', width: '25%'}}/>
                </ParallaxLayer>
                <ParallaxLayer offset={2.6} speed={.8}>
                    <img src={speaker} style={{marginLeft: '28%', width: '5%'}}/>
                </ParallaxLayer>
                <ParallaxLayer offset={2.6} speed={.9}>
                    <img src={speaker} style={{marginLeft: '68%', width: '5%'}}/>
                </ParallaxLayer>

                <ParallaxLayer offset={2.8} speed={.6}>
                    <img src={keyboard} style={{marginLeft: '38%', width: '30%'}}/>
                </ParallaxLayer>




                <ParallaxLayer offset={0} speed={0.1} onClick={() => this.parallax.scrollTo(1)}/>
                <ParallaxLayer offset={1} speed={0.1} onClick={() => this.parallax.scrollTo(2)}/>
                <ParallaxLayer offset={2} speed={0.1} onClick={() => this.parallax.scrollTo(0)}/>

            </Parallax>
        </div>
        )
    }

}
export default Interests